import { Select, Input } from 'mdb-ui-kit';



let selects = document.querySelectorAll( '.selectpicker' );
for (var i = 0; i < selects.length; i++) {

    let select = new Select( selects[i] );

}


// jQuery(document.body).on('update_checkout', function(e){

//        // e.preventDefault();


//         for (var i = 0; i < selects_array.length; i++) {

//             selects_array[i].dispose();
//         }

//         selects_array = [];
//         selects = document.querySelectorAll( 'select' );
//         for (var i = 0; i < selects.length; i++) {

//             let select = new Select( selects[i] );
//             selects_array.push( select );
//         } 

// });


// billing_state


jQuery('body').on('updated_checkout', function(event, json, string){
            
    document.querySelectorAll('.form-outline').forEach((input) => {

        new Input( input ).init();
//
    });  

});


